import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { ModalContext } from "../contexts/ModalContext";
import { Context } from "../contexts/AppContext";
import NewGalleryCreateP from "../PropertyList/NewGalleryCreateP";
import { postData } from "../../lib/utils";
import { useNavigate } from "react-router-dom";
import VideoPlayerP from "../PropertyList/VideoPlayerP";
function VideoPlayerModal() {

  const navigate = useNavigate();
  const [galleryName, setGalleryName] = useState(null);
 

 
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [modalOpen, setModalOpen] = useState(appState.modalData);
 
 
  Modal.setAppElement("#root");

   useEffect(() => {
     setModalOpen(appState.modalData); 
   }, [appState.modalData]);
    

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "auto",
      height: "98%",
      
      overflow: "hidden",
      border:"1px solid #00bcd4",
      borderRadius:"10px"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.9)",
    },
  };

  const closeModal = () =>  { 
    setAppState((prevState) => {
      return { ...prevState, 
        modalData:{ ...prevState.modalData, type: null, isOpen: false}};
    }); 
    }

  const btnHandler = async (type) => {
    if (type === "save" && galleryName) {
      
      const json = await postData("galleries/create", {
        name: galleryName,
        folderId: appState.allFolderData[appState.currentFolderId]._id,
      });
      if (json) {
        setAppState((prevState) => ({ ...prevState, currentGalleryName: galleryName, temp:"shyam" }));
       
        closeModal();
        navigate(`/studio`);
      }
    } else {
      closeModal();
    }
  };

  return (
    <Modal isOpen={modalOpen.isOpen} onRequestClose={closeModal} style={customStyles}>
   
      <VideoPlayerP updateGalleryData={setGalleryName} />
 
    </Modal>
  );
}

export default VideoPlayerModal;
